import { Button } from "@mui/material";

const AccessControlCell = ({ user, accessType, onAction }) => {
  const hasAccess = accessType === "fraction" 
    ? user.frac_access 
    : user.hires_access;

  const handleClick = (action) => {
    onAction(user, accessType, action);
  };

  return (
    <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
      {hasAccess ? (
        <Button
          variant="contained"
          size="small"
          onClick={() => handleClick("deny")}
          sx={{
            backgroundColor: "#dc3545",
            "&:hover": { backgroundColor: "#c82333" },
            textTransform: "none",
            fontSize: "0.75rem",
            padding: "4px 12px",
          }}
        >
          Deny
        </Button>
      ) : (
        <Button
          variant="contained"
          size="small"
          onClick={() => handleClick("grant")}
          sx={{
            backgroundColor: "#28a745",
            "&:hover": { backgroundColor: "#218838" },
            textTransform: "none",
            fontSize: "0.75rem",
            padding: "4px 12px",
          }}
        >
          Grant
        </Button>
      )}
    </div>
  );
};

export default AccessControlCell;